export const MARKET_MAP_PL = "MARKET_MAP_PL";
export const MARKET_MAP_PL_ERROR = "MARKET_MAP_PL_ERROR";
export const MARKET_MAP_PL_HIDE_ERROR = "MARKET_MAP_PL_HIDE_ERROR";
export const MARKET_MAP_PL_START_LOADER = "MARKET_MAP_PL_START_LOADER";
export const MARKET_MAP_PL_STOP_LOADER = "MARKET_MAP_PL_STOP_LOADER";
